// extracted by mini-css-extract-plugin
export var lg = "_3l-4";
export var md = "_3l-3";
export var sm = "_3l-2";
export var xs = "_3l-1";
export var xxs = "_3l-0";